import { useQuery } from '@tanstack/react-query';
import { get } from './api.js';
import { todayISO } from './format.js';

/**
 * Day for the Present headcount tiles.
 *
 * Always today. `/attendance/summary` builds a full active roster (including
 * unmarked people as absent / leave / weekly off), so there is no need to fall
 * back to the last “fat” trend day — that left Headcount on today and Present
 * on yesterday with mismatched denominators.
 */
export function useAttendanceDay() {
  const today = todayISO();

  const summary = useQuery({
    queryKey: ['attendance', 'summary', today],
    queryFn: () => get('/attendance/summary', { date: today }),
  });

  return {
    summary: summary.data?.data ?? null,
    date: today,
    isToday: true,
    label: 'today',
    isLoading: summary.isLoading,
  };
}
